export const PRESIDENT_ADDRESS_PAGE =
  "sidang-parlimen-singapura-8-september-2026";
export const PRESIDENT_ADDRESS_TAGS = "bhparliamentsg";

export const PRESIDENT_ADDRESS_BANNER_LIVE_INDICATOR =
  import.meta.env.VITE_PRESIDENT_ADDRESS_LIVE_INDICATOR === "1";
